module.exports = __webpack_public_path__ + "img/SEGURIFY_logo_BCO.7f070ff2.png";